import React, { useState } from 'react';
import { fget, fput } from 'src/lib/fetch';
import { PILOT_STATUS } from 'src/constants/pilotStatus';

interface DeviceData {
    DEVICE_ID: { S: string };
    DEVICE_NAME: { S: string };
    AREA_NAME: { S: string };
    DEVICE_COORDINATE: { S: string };
    DEVICE_STATUS: { S: string };
    DEVICE_TYPE: { S: string };
    DEVICE_NUMBER: { S: string };
    RIVER_NAME: { S: string };
    INSTALL_DATE: { S: string };
    REMOVE_DATE: { S: string };
    POSITIONS: { S: string };
    WATER_LEVEL: { S: string };
    FLOW_RATE: { S: string };
    WATER_LEVEL_STATUS: { S: string };
    VELOCITY_STATUS: { S: string };
    WATER_FLOW_STATUS: { S: string };
    WATER_LEVEL_FORMULA: { S: string };
    VELOCITY_FORMULA: { S: string };
    FLOW_RATE_FORMULA: { S: string };
    CROSS_SECTION_FORMULA: { S: string };
    WATER_LEVEL_THRESHOLD: { S: string };
    VELOCITY_THRESHOLD: { S: string };
    WATER_FLOW_THRESHOLD: { S: string };
    ALERT_RECEIPT_EMAIL: { S: string };
    CONNECTED_DEVICE_IDS: { L: any[] };
    REMOVE_DATE_HISTORIES: { L: any[] };
    is_client_flow?: boolean;
    isPilotPassed?: boolean;
    passedTime?: string | Date | null;
    passTimestamp?: string | number | null;
    predicted_time?: number | null;
    predicted_ranges?: number | null;
    pilot_status?: string;
    [key: string]: any;
}

interface GraphSettingsPopupProps {
    isOpen: boolean;
    onClose: () => void;
    deviceData: DeviceData,
    predictedTimeConvert?: string; // Optional prop for predicted time conversion
    passedTimeConvert?: string; // Optional prop for passed time conversion
    deviceOrder: string[]; // Optional prop for device order
}

export const GraphSettingsPopup: React.FC<GraphSettingsPopupProps> = ({
    isOpen,
    onClose,
    deviceData,
    predictedTimeConvert,
    passedTimeConvert,
    deviceOrder
}) => {
    const newDeviceData = { ...deviceData };
    const [selectedType, setSelectedType] = useState('passed');
    const [selectedTime, setSelectedTime] = useState('predicted');
    const [timeInput, setTimeInput] = useState('');
    const defaultConfirmType = deviceData?.pilot_status === PILOT_STATUS.PASSED ? 'reset_pilot' : 'passed';
    const [confirmType, setConfirmType] = useState(defaultConfirmType);
    console.log('confirmType', confirmType);

    const deviceName = deviceData?.DEVICE_NAME?.S || 'Unknown Device'; // Assuming deviceData has DEVICE_NAME property

    const setIsCheckingPilot = () => {
        // dua vao deviceOrder de set isPilotCheck = true cho thiet bi gan nhat phia sau
        const currentIndex = deviceOrder.indexOf(deviceData.DEVICE_ID.S);
        console.log('Current Index:', currentIndex);

        if (currentIndex !== -1 && currentIndex < deviceOrder.length - 1) {

            const nextDeviceId = deviceOrder[currentIndex + 1];
            console.log('Next Device ID:', nextDeviceId);

            // call api get data cua thiet bi tiep theo
            fget<any, any>(`/api/areas/nodes/${deviceData.AREA_NAME.S}/${nextDeviceId}`)
                .then(([_, nextDevice]) => {
                    if (nextDevice) {
                        const nextDeviceData = JSON.parse(nextDevice.DATA.S || '{}');
                        nextDeviceData.isPilotCheck = true;

                        // call api put de update isPilotCheck = true
                        fput<any, any>(`/api/areas/nodes/${deviceData.AREA_NAME.S}/${nextDeviceId}/data`, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: {
                                data: nextDeviceData
                            },
                        }).then(([__, data]) => {
                            console.log('Update next device success:', data);
                        }).catch((err) => {
                            console.error('Update next device failed:', err);
                        });
                    }
                }
                ).catch((err) => {
                    console.error('Fetch next device data failed:', err);
                });
        }
    }

    const getTimeFromInput = () => {
        let hours = 0, minutes = 0;
        if (deviceData.pilot_status === PILOT_STATUS.NOT_PASS) {
            [hours, minutes] = timeInput.split(':').map(Number);
        } else if (deviceData.pilot_status === PILOT_STATUS.CONFIRMING) {
            if (passedTimeConvert) {
                [hours, minutes] = passedTimeConvert.split(':').map(Number);
            }
        }
        
        const now = new Date();
        now.setHours(hours, minutes, 0, 0);
        return now;
    };

    const resetPilotData = () => {
        newDeviceData.isPilotPassed = false;
        newDeviceData.passedTime = null;
        newDeviceData.passTimestamp = null;
    };

    const setPilotPassed = (time: Date) => {
        newDeviceData.isPilotPassed = true;
        newDeviceData.passedTime = time;
        newDeviceData.passTimestamp = time.getTime();
        newDeviceData.predicted_time = null;
        newDeviceData.isPilotCheck = false;
        setIsCheckingPilot();
    };

    const handleNotPassStatus = (time: Date) => {
        console.log('NOT_PASS confirmType', confirmType);
        setPilotPassed(time);
        newDeviceData.pilot_status = PILOT_STATUS.PASSED;
    };

    const handlePassedStatus = (time: Date) => {
        console.log('PASSED confirmType', confirmType);
        if (confirmType === 'reset_pilot') {
            newDeviceData.isPilotPassed = false;
            newDeviceData.passedTime = null;
            newDeviceData.passTimestamp = null;
            newDeviceData.predicted_time = null;
            newDeviceData.predicted_ranges = null;
            newDeviceData.pilot_status = PILOT_STATUS.NOT_PASS;
            newDeviceData.isPilotCheck = false;
        } else {
            return 'reset'
        }
    };

    const handleConfirmingStatus = (time: Date) => {
        console.log('CONFIRMING confirmType', confirmType);
        newDeviceData.pilot_status = confirmType;

        if (confirmType === PILOT_STATUS.PASSED) {
            console.log('Set to PASSED');
            setPilotPassed(time);
        } else {
            resetPilotData();
        }
    };

    const updateDeviceData = async () => {
        try {
            const [_, data] = await fput<any, any>(`/api/areas/nodes/${deviceData.AREA_NAME.S}/${deviceData.DEVICE_ID.S}/data`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: {
                    data: newDeviceData
                },
            });
            window.location.reload();
            console.log('Update success:', data);
        } catch (err) {
            console.error('Update failed:', err);
            alert('データの更新に失敗しました。');
        }
    };

    const handleSubmit = () => {
        if (!selectedType || !selectedTime) {
            alert('タイプと時間を選択してください。');
            return;
        }

        if (newDeviceData.pilot_status === PILOT_STATUS.NOT_PASS) {
            const validateTimeInput = (timeValue: string): boolean => {
                if (!timeValue) return false;

                const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
                return timeRegex.test(timeValue);
            };
            const isValidTime = validateTimeInput(timeInput);
            if (!isValidTime) {
                alert('入力した時間は不適切です。HH:MMで入力してください。');
                return;
            }
        }

        const time = getTimeFromInput();

        let reset:string | undefined;
        if (newDeviceData.pilot_status === PILOT_STATUS.NOT_PASS) {
            handleNotPassStatus(time);
        } else if (newDeviceData.pilot_status === PILOT_STATUS.PASSED) {
            reset = handlePassedStatus(time);
        } else if (newDeviceData.pilot_status === PILOT_STATUS.CONFIRMING) {
            handleConfirmingStatus(time);
        }

        if (reset !== 'reset') {
            updateDeviceData();
        }
        onClose();
    };

    const renderRadioOption = (value: string, label: string, isDefault = false) => (
        <label className="inline-flex items-center">
            <input
                type="radio"
                className="form-radio"
                name="type"
                value={value}
                defaultChecked={isDefault}
                onChange={(e) => setConfirmType(e.target.value)}
            />
            <span className="ml-2 text-gray-600 text-sm">{label}</span>
        </label>
    );

    const renderNotPassContent = () => (
        <>
            <div className="mb-4">
                <p className="text-sm font-medium mb-2">タイプを選択: {predictedTimeConvert}</p>
            </div>
            <div className="mb-4">
                <label htmlFor="time-input" className="block text-sm font-medium mb-2">
                    時間を選択:
                </label>
                <input
                    id="time-input"
                    type="time"
                    value={timeInput}
                    onChange={(e) => setTimeInput(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>
        </>
    );

    const renderConfirmingContent = () => (
        <>
            <div className="mb-4">
                <p className="text-sm font-medium mb-2 text-red-600">水先到達時間: {passedTimeConvert}</p>
            </div>
            <div>
                <p className="text-sm mb-2">水先判断を選択：</p>
            </div>
            <div className="flex flex-col gap-2 mb-4">
                {renderRadioOption(PILOT_STATUS.PASSED, "水先到達時間を確定", true)}
                {renderRadioOption(PILOT_STATUS.NOT_PASS, "判定をスルーする")}
            </div>
        </>
    );

    const renderPassedContent = () => (
        <>
            <div className="mb-4">
                <p className="text-sm font-medium mb-2">水先到達時間: {passedTimeConvert}</p>
            </div>
            <div className="mb-4">
                <p className="text-sm">水先到達の確定を解除し、水先判定を行う：</p>
            </div>
            <div className="flex flex-col gap-2 mb-4">
                {renderRadioOption('reset_pilot', "はい", true)}
                {renderRadioOption('none', "いいえ")}
            </div>
        </>
    );

    const renderStatusContent = () => {
        if (deviceData.pilot_status === PILOT_STATUS.NOT_PASS) {
            return renderNotPassContent();
        } else if (deviceData.pilot_status === PILOT_STATUS.CONFIRMING) {
            return renderConfirmingContent();
        } else if (deviceData.pilot_status === PILOT_STATUS.PASSED) {
            return renderPassedContent();
        }
        return null;
    };

    if (!isOpen) return null;

    return (
        <>
            {/* Overlay */}
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50" />

            {/* Popup Modal */}
            <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg z-50 min-w-[350px]">
                <h3 className="text-lg font-semibold mb-4">水先判定</h3>
                <p className="text-sm text-gray-600 mb-4">デバイス: {deviceName}</p>

                {/* Time input */}
                {renderStatusContent()}

                {/* Buttons */}
                <div className="flex gap-2 justify-between">
                    <button
                        onClick={onClose}
                        className="px-5 py-2 text-gray-600 bg-gray-200 rounded hover:bg-gray-300 text-sm"
                    >
                        キャンセル
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-7 py-2 bg-emerald-600 text-white rounded hover:bg-emerald-700 text-sm"
                    >
                        確認
                    </button>
                </div>
            </div>
        </>
    );
};
